import { render, staticRenderFns } from "./ReLogin.vue?vue&type=template&id=da2f3ae8&scoped=true"
import script from "./ReLogin.vue?vue&type=script&lang=js"
export * from "./ReLogin.vue?vue&type=script&lang=js"
import style0 from "./ReLogin.vue?vue&type=style&index=0&id=da2f3ae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da2f3ae8",
  null
  
)

export default component.exports